import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Send, Paperclip } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { http, formatApiError } from "../lib/api";

const inp = "w-full border border-slate-300 rounded-md px-3 py-2 text-sm";

export const MailResendDialog = ({ endpoint, entry, onClose, onDone }) => {
  const [d, setD] = useState(null);
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!entry) return;
    setD(null);
    http.get(`${endpoint}/${entry.id}`).then((r) => { setD(r.data); setTo(r.data.to); setSubject(r.data.subject); }).catch((e) => { toast.error(formatApiError(e)); onClose(); });
  }, [entry]); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    setBusy(true);
    const html = ref.current?.innerHTML;
    const body = { to: to !== d.to ? to : null, subject: subject !== d.subject ? subject : null, html: html && html !== d.html ? html : null };
    try {
      const { data } = await http.post(`${endpoint}/${entry.id}/resend`, body);
      data.sent ? toast.success("E-mail renvoyé") : toast.error(`Nouvel échec : ${data.reason || "inconnu"}`);
      onDone();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!entry} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="mail-resend-dialog">
        <DialogHeader><DialogTitle>Renvoyer l'e-mail</DialogTitle></DialogHeader>
        {!d ? <p className="text-sm text-slate-500">Chargement…</p> : (
          <div className="space-y-3">
            <label className="block"><span className="text-[11px] text-slate-500">Destinataire</span><input type="email" className={inp} value={to} onChange={(e) => setTo(e.target.value)} data-testid="mail-resend-to" /></label>
            <label className="block"><span className="text-[11px] text-slate-500">Objet</span><input className={inp} value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="mail-resend-subject" /></label>
            {d.attachments.length > 0 && <div className="text-xs text-slate-600 flex flex-wrap gap-2" data-testid="mail-resend-attachments">{d.attachments.map((a) => <span key={a} className="inline-flex items-center gap-1 bg-slate-100 rounded px-2 py-1"><Paperclip className="h-3 w-3" />{a}</span>)}</div>}
            <div>
              <span className="text-[11px] text-slate-500">Contenu — cliquez dans le texte pour le modifier si besoin</span>
              <div ref={ref} contentEditable suppressContentEditableWarning className="mt-1 border border-slate-300 rounded-md p-3 max-h-[45vh] overflow-y-auto focus:outline-none focus:ring-2 focus:ring-[#C9962E]" dangerouslySetInnerHTML={{ __html: d.html }} data-testid="mail-resend-content" />
            </div>
            <div className="flex justify-end gap-2 pt-1">
              <button type="button" onClick={onClose} className="px-4 py-2 rounded-md border border-slate-300 text-sm" data-testid="mail-resend-cancel">Annuler</button>
              <button type="button" onClick={send} disabled={busy || !to.includes("@")} className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold disabled:opacity-50" data-testid="mail-resend-send"><Send className="h-4 w-4" />{busy ? "Envoi…" : "Renvoyer"}</button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
